import api from "../../services/api";

const useResellerTransactions = () => {
    const getTransactions = async (resellerId) => {
        const { data } = await api.get(`/reseller-transactions/${resellerId}`);
        return data;
    };

    const rechargeBalance = async (companyId, resellerPlanId) => {
        const { data } = await api.post(`/reseller-transactions/recharge`, {
            companyId,
            resellerPlanId,
        });
        return data;
    };

    const absorbClients = async (resellerId) => {
        const { data } = await api.post(`/reseller-transactions/absorb`, {
            resellerId,
        });
        return data;
    };

    return { getTransactions, rechargeBalance, absorbClients };
};

export default useResellerTransactions;
